import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiGetPayTypes, apiGetSelFreight, apiSubmitOrder, apiUploadPic } from '../api';
import { LoadingMask, showConfirm, showToast } from '../components/dialog';
import MCityPicker from '../components/m_city_picker/m_city_picker';
import Page from '../components/page';
import Radiobox from '../components/radioBox';
import main from '../main';
import { goodsDetailRequest } from '../redux/goodsDetailReducer';
import { AppStore } from '../types';
import { PayType, payOrder } from '../utils/pay';
import { dataDetailStatus, formatNumber, parseLocationParams, validateCardId, validateTel } from '../utils/utils';
import { ProtocolType } from './protocolPage';

// const dtime = 60;
export default function GoodsDetailPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [canBack, setCanBack] = useState(false);
  const [shareUserId, setShareUserId] = useState('');
  const [goodsId, setGoodsId] = useState('');
  // 运费
  const [freight, setFreight] = useState<number>(0);
  const goods = useSelector((state: AppStore) => state.goodsDetail[goodsId]);

  // const timeRef = useRef<{ timer?: NodeJS.Timeout; time?: number }>({});
  // const [time, setTime] = useState(0);
  //----
  const [cardId, setCardId] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  // const [smsCode, setSmsCode] = useState('');
  const [province, setProvince] = useState('');
  const [origin, setOrigin] = useState('');
  const [city, setCity] = useState('');
  const [area, setArea] = useState('');
  const [address, setAddress] = useState('');
  const [checkProtocol, setCheckProtocol] = useState(false);
  // 支付方式（按后台支付配置显隐）
  const [payType, setpayType] = useState<string>('');
  const [enabledPayTypes, setEnabledPayTypes] = useState<string[]>([]);
  const [avatarImg, setAvatarImg] = useState('');
  const [nationalEmblemImg, setNationalEmblemImg] = useState('');
  const [handPhotoImg, setHandPhotoImg] = useState('');
  const [definedPhotoImg, setDefinedPhotoImg] = useState('');

  useEffect(() => {
    let { userId: uid, form: origin, goodsId: gid, canBack: cb } = parseLocationParams(location.search);
    if (uid) {
      setShareUserId(uid);
    }
    if (origin) {
      setOrigin(origin);
    }
    if (gid) {
      setGoodsId(gid);
      dispatch(goodsDetailRequest({ id: gid }));
    } else {
      navigate(-1);
    }
    if (cb === 'true') {
      setCanBack(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]); /// eslint-disable-line

  // 支付方式按后台支付配置显隐
  useEffect(() => {
    apiGetPayTypes()
      .then((res: any) => {
        let list: string[] = res?.data?.data ?? [];
        setEnabledPayTypes(list);
        setpayType((cur) => (cur && list.includes(cur) ? cur : defaultPayType(list)));
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function defaultPayType(list: string[]) {
    if (!list.length) return '';
    if (main.isWexin && list.includes(PayType.WECHAT)) return PayType.WECHAT;
    if (list.includes(PayType.ALIPAY)) return PayType.ALIPAY;
    return list[0];
  }

  async function handleSelectCity(res: string[]) {
    setProvince(res[0]);
    setCity(res[1]);
    setArea(res[2]);
    if (res[1]) {
      getSelFreight(res[1]);
    }
  }
  // 获取运费
  async function getSelFreight(cityName: string) {
    let res = await apiGetSelFreight({ cityName, bussGoodsId: detail?.id });
    let data = res.data;
    if (data.code === 200) {
      setFreight(Number(data?.data?.freight ?? 0));
    }
  }
  // 校验详细地址是否包含省/市/区信息
  function validateAddress() {
    if (province.includes('市')) return true;
    const shouldValidate = !!province && !!city;
    if (!shouldValidate) {
      return true;
    }
    // 过滤非空的省市关键词
    const locationCores = [province, city].filter(Boolean);
    // 检查详细地址是否包含任一关键词
    const hasDuplicate = locationCores.filter((core) => address.includes(core));
    if (hasDuplicate.length === locationCores.length) {
      showToast('已选择省/市信息，请勿在详细地址再次输入省、市等信息！');
      return false;
    }
    return true;
  }
  async function handleSubmitOrder() {
    if (!validateAddress()) return;
    let detail = goods!.result!;
    if (detail.ifReal === 'Y') {
      if (!cardId) {
        return showToast('请输入身份证号码');
      } else if (!validateCardId(cardId)) {
        return showToast('请输入正确的身份证号码');
      }
    }
    if (!name) {
      return showToast('请输入客户姓名');
    }
    if (!validateTel(phone)) {
      return showToast('请输入正确的联系电话');
    }
    // if (!smsCode) {
    //   return showToast('请输入短信验证码');
    // }
    if (!province) {
      return showToast('请选择城市');
    }
    if (!address) {
      return showToast('请输入详细地址');
    }
    if (detail?.ifPhoto === 'Y' && !avatarImg) {
      return showToast('请上传身份证人像面');
    }
    if (detail?.ifPhoto === 'Y' && !nationalEmblemImg) {
      return showToast('请上传身份证国徽面');
    }
    if (detail?.ifPhoto === 'Y' && !handPhotoImg) {
      return showToast('请上传本人照片');
    }
    if (detail?.isDefinedPhoto === 'Y' && !definedPhotoImg) {
      return showToast('请上传一证通照片');
    }
    if (!checkProtocol) {
      let res = await showConfirm({ title: '提示', content: '请阅读并同意《入网》', confirmBtnText: '同意协议' });
      if (res !== 1) return;
    }
    LoadingMask.show('正在提交...');
    let selectedPayType = payType || defaultPayType(enabledPayTypes);
    try {
      let res = await apiSubmitOrder({
        goodsId: detail.id,
        cardNo: cardId,
        receiverName: name,
        receiverPhone: phone,
        province: province,
        city: city,
        county: area,
        receiverAddress: address,
        payType: selectedPayType, //'wechat' ??
        payWay: 'js',
        openId: main.openId, //  'oz7c96307K0P10xOR8Sg87k1Lbk4' ??
        shareUserId,
        // smsCode,
        pageSource: 'h5',
        orderSource: origin,
        avatarImg,
        nationalEmblemImg,
        handPhotoImg,
        definedPhotoImg,
      });
      let data = res.data;
      let orderSn = '';
      if (data.code === 200) {
        orderSn = data.data.orderSn ?? '';
        if ((detail.goodsPrice ?? 0) <= 0) {
          showToast('下单成功');
          // 不用支付的订单
          handlePaySuccess(orderSn);
        } else {
          var payRes = await payOrder(selectedPayType, data.data);
          if (payRes.code === 200) {
            // 支付直接成功的
            showToast(payRes.msg);
            handlePaySuccess(orderSn);
          } else if (payRes.code === 300) {
            if (payRes.url && payRes.url.startsWith('http')) {
              window.location.href = payRes.url;
              return;
            }
            let div = document.createElement('div');
            div.innerHTML = payRes.url;
            div.style.display = 'none';
            document.body.appendChild(div);
            document.forms[0].submit();
          } else if (payRes.code === 500) {
            // 支付失败的
            showToast(payRes.msg ?? '下单失败');
          }
        }
      } else {
        showToast(data.msg ?? '下单失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '提交失败');
    } finally {
      LoadingMask.hide();
    }
  }

  function handlePaySuccess(sn: string) {
    navigate(`/success?orderSn=${sn}&goodsTitle=${detail.goodsTitle}&time=${dayjs().format('YYYY-MM-DD HH:mm:ss')}`);
  }
  // 获取验证码
  // async function handleSendSms() {
  //   if (!validateTel(phone)) {
  //     return showToast('请输入正确的联系电话');
  //   }
  //   LoadingMask.show('正在发送...');
  //   try {
  //     const timestamp = getCurrentTimestamp();
  //     const str = encrypt(phone + timestamp);
  //     const randomStr = generateRandomString(4);
  //     if (typeof str !== 'string') {
  //       return;
  //     }
  //     const NewStr = insertAtPosition(str, randomStr, 11);
  //     let res = await apiGetSmsCode(NewStr);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       showToast('发送成功');
  //       timeRef.current.time = dtime;
  //       timeRef.current.timer = setInterval(() => {
  //         setTime(timeRef.current.time!--);
  //         if (timeRef.current.time! <= 0) {
  //           clearInterval(timeRef.current.timer);
  //         }
  //       }, 1000);
  //     } else {
  //       showToast(data.msg);
  //     }
  //   } catch (e: any) {
  //     showToast(e.message);
  //   } finally {
  //     LoadingMask.hide();
  //   }
  // }

  function handleToShare() {
    let detail = goods!.result!;
    navigate(`/share`, {
      state: {
        imgUrl: detail.goodsDetailImg ?? '',
        title: detail.goodsTitle ?? '',
        inviteUserId: '',
        goodsId: detail.id,
      },
    });
  }

  let el = dataDetailStatus({ detail: goods });
  if (el) {
    return <Page>{el}</Page>;
  }
  let detail = goods.result!;
  return (
    <Page className="bg-color-gray" contentClassName="vw-100 vh-100 pos-r">
      <div className="vw-100 vh-100 overflow-hidden pos-r z-0 d-flex-c">
        <div className="flex-1 h-1 overflow-y">
          <img className="bw-100 h-375" src={detail.goodsDetailImg} alt="" />
          <div className="bg-color-white p-10">
            <div className="font-size-16 font-widget-600">{detail.goodsTitle ?? ''}</div>
            <div className="d-flex-r ai-start pt-10">
              <div className="flex-1 d-flex-r flex-wrap">
                {!!detail.goodsTitleTags &&
                  detail.goodsTitleTags!.split(',').map((i, idx) => (
                    <div
                      key={i + idx}
                      className="border-radius-4 bg-color-red-t3 text-color-red font-size-12 ph-5 pv-2 mr-5 mb-5"
                    >
                      {i}
                    </div>
                  ))}
              </div>
              <div className="font-siez-12 text-color-6">销量{detail.virtualSales ?? 0}</div>
            </div>
            <div className="text-color-9 font-size-12">
              {detail.goodsTags ?? ''}
              {!!detail.goodsTags && !!detail.goodsSpac ? '+' : ''}
              {detail.goodsSpac ?? ''}
            </div>
          </div>

          <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red">*</span>客户姓名
            </div>
            <input
              className="flex-1 font-size-14"
              placeholder="输入客户姓名"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          {detail.ifReal === 'Y' && (
            <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
              <div className="w-100">
                <span className="text-color-red">*</span>身份证号码
              </div>
              <input
                className="flex-1 font-size-14"
                placeholder="输入身份证号码"
                value={cardId}
                onChange={(e) => setCardId(e.target.value)}
              />
            </div>
          )}
          <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red">*</span>收件联系电话
            </div>
            <input
              className="flex-1 font-size-14"
              placeholder="输入收件联系电话"
              value={phone}
              maxLength={11}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          {/* <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red">*</span>验证码
            </div>
            <input
              className="flex-1 font-size-14"
              placeholder="输入验证码"
              value={smsCode}
              maxLength={6}
              onChange={(e) => setSmsCode(e.target.value)}
            />
            <Button type="primary" shape="circle" size="xs" disabled={time > 0} onClick={handleSendSms}>
              {time > 0 ? `${time}(s)` : '发送验证码'}
            </Button>
          </div> */}
          <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red">*</span>城市选择
            </div>
            <MCityPicker onChange={handleSelectCity} />
          </div>
          {/* <div className="mh-10 mt-10 bg-color-white border-radius-8 p-10 d-flex-r">
            <div className="w-80">城市选择</div>
            <div className={`flex-1 ${!!province ? 'text-color-3' : 'text-color-6'}`} onClick={handleSelectCity}>
              {!!province ? `${province ?? ''}${city ?? ''}${area ?? ''}` : '请选择城市'}
            </div>
          </div> */}

          <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
            <div className="w-100">
              <span className="text-color-red">*</span>详细地址
            </div>
            <input
              type="text"
              className="flex-1 font-size-14"
              placeholder="输入详细地址"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmitOrder();
                }
              }}
            />
          </div>
          {freight > 0 && (
            <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14 d-flex-r ai-center font-size-14">
              <div className="w-100 pl-7">价格明细</div>
              <div className="text-color-9">
                售价：¥{formatNumber(detail?.goodsPrice)}
                （运费：¥{formatNumber(freight)}）
              </div>
            </div>
          )}
          {detail.ifPhoto === 'Y' && (
            <div className="mh-10 mt-7 bg-color-white border-radius-8 p-14">
              <div className="font-size-16 font-widget-600">上传证件</div>
              <div className="text-color-red font-weight-600 text-center">
                根据有关部门要求，必需上传真实身份证照片。未上传照片，订单无效。
              </div>

              <div className="bg-color-gray border-radius-8 p-10 mt-10 d-flex-c ai-center pos-r">
                {!!avatarImg ? (
                  <img className="w-282 h-154 border-radius-10" src={avatarImg} alt="" />
                ) : (
                  <div className="pos-r">
                    <img src={main.pic('iccid1.png')} className="w-282 h-154 border-radius-10 pos-r z-0" alt="" />
                    <div className="pos-a z-1 t-0 l-10 r-10 b-0 d-flex-c ai-center jc-center">
                      <img src={main.pic('icon_upload_c.png')} className="w-60 h-60" alt="" />
                      <div className="mt-10 text-color-white">请上传身份证头像面</div>
                    </div>
                  </div>
                )}
                <div className="font-12 w-282 text-center">
                  手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    console.log('e.target.files', e.target.files);
                    if (e.target.files) {
                      apiUploadPic(e.target.files[0]).then((url) => {
                        setAvatarImg(url ?? '');
                      });
                    }
                  }}
                  className="pos-a bw-100 t-0 b-0 z-10 opacity-0"
                />
              </div>
              <div className="bg-color-gray border-radius-8 p-10 mt-10 d-flex-c ai-center pos-r">
                {!!nationalEmblemImg ? (
                  <img className="w-282 h-154 border-radius-10" src={nationalEmblemImg} alt="" />
                ) : (
                  <div className=" pos-r">
                    <img src={main.pic('iccid2.png')} className="w-282 h-154 border-radius-10 pos-r z-0" alt="" />
                    <div className="pos-a z-1 t-0 l-10 r-10 b-0 d-flex-c ai-center jc-center">
                      <img src={main.pic('icon_upload_c.png')} className="w-60 h-60" alt="" />
                      <div className="mt-10 text-color-white">请上传身份证国徽面</div>
                    </div>
                  </div>
                )}
                <div className="font-12 w-282 text-center">
                  手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    console.log('e.target.files', e.target.files);
                    if (e.target.files) {
                      apiUploadPic(e.target.files[0]).then((url) => {
                        setNationalEmblemImg(url ?? '');
                      });
                    }
                  }}
                  className="pos-a bw-100 t-0 b-0 z-10 opacity-0"
                />
              </div>
              <div className="bg-color-gray border-radius-8 p-10 mt-10  d-flex-c ai-center pos-r">
                {!!handPhotoImg ? (
                  <img className="w-282 h-154 border-radius-10" src={handPhotoImg} alt="" />
                ) : (
                  <div className=" pos-r">
                    <img src={main.pic('iccid3.png')} className="w-282 h-154 border-radius-10 pos-r z-0" alt="" />
                    <div className="pos-a z-1 t-0 l-10 r-10 b-0 d-flex-c ai-center jc-center">
                      <img src={main.pic('icon_upload_c.png')} className="w-60 h-60" alt="" />
                      <div className="mt-10 text-color-white">请上传本人照片</div>
                    </div>
                  </div>
                )}
                <div className="font-12 w-282 text-center">
                  请拍摄本人真实环境清晰正面免冠人像，不能反光，有水印，PS:上传证件照等。
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    console.log('e.target.files', e.target.files);
                    if (e.target.files) {
                      apiUploadPic(e.target.files[0]).then((url) => {
                        setHandPhotoImg(url ?? '');
                      });
                    }
                  }}
                  className="pos-a bw-100 t-0 b-0 z-10 opacity-0"
                />
              </div>
              {detail.isDefinedPhoto === 'Y' && (
                <div className="bg-color-gray border-radius-8 p-10 mt-10  d-flex-c ai-center pos-r">
                  {!!definedPhotoImg ? (
                    <img className="w-282 h-154 border-radius-10" src={definedPhotoImg} alt="" />
                  ) : (
                    <div className="pos-r">
                      <img src={main.pic('iccid4.png')} className="w-282 h-154 border-radius-10 pos-r z-0" alt="" />
                      <div className="pos-a z-1 t-0 l-0 r-0 b-0 d-flex-c ai-center jc-center bg-color-black-t5 border-radius-10">
                        <img src={main.pic('icon_upload_c.png')} className="w-60 h-60" alt="" />
                        <div className="mt-10 text-color-white">请上传一证通短信截图</div>
                      </div>
                    </div>
                  )}
                  <div className="font-12 w-282 text-center">
                    一证通查信息(上传名下号码数量短信截图，可通过下列“一证通查询”入口查询，收到短信后上传)
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      console.log('e.target.files', e.target.files);
                      if (e.target.files) {
                        apiUploadPic(e.target.files[0]).then((url) => {
                          setDefinedPhotoImg(url ?? '');
                        });
                      }
                    }}
                    className="pos-a bw-100 t-0 b-50 z-10 opacity-0"
                  />
                  <div
                    className="mt-10 lh-32 text-center w-282 h-32 border-radius-10  bg-color-primary font-size-16 text-color-white"
                    onClick={() => {
                      window.open('https://getsimnum.caict.ac.cn/m/#/', '_blank');
                    }}
                  >
                    一证通查
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="d-flex-r ai-center jc-center p-10">
            <Radiobox value={checkProtocol} onChange={(v) => setCheckProtocol(!checkProtocol)} />
            <span className="font-size-12 text-color-6 ml-5" onClick={() => setCheckProtocol(!checkProtocol)}>
              我已阅读并同意上述描述及
            </span>
            <span
              className="font-size-12 text-color-primary ml-5"
              onClick={() => navigate('/protocol?type=' + ProtocolType.net_in)}
            >
              《入网协议》
            </span>
          </div>
          {enabledPayTypes.length > 0 && (
            <div className="ml-7 mr-7 mb-10 d-shadow bg-color-white border-radius-4 p-10">
              <div className="mt-5 mb-10 font-size-14 font-widget-600">支付方式</div>
              {enabledPayTypes.includes(PayType.WECHAT) && (
                <div
                  className="d-flex-r ai-center jc-between font-size-14 pv-8"
                  onClick={() => setpayType(payType === PayType.WECHAT ? '' : PayType.WECHAT)}
                >
                  <div className="d-flex-r ai-center">
                    <img className="w-20 h-20 mr-10" src="/pic/icon_pay_wechat.png" alt="" />
                    <span className="d-inline-block line-height-0">微信支付</span>
                  </div>
                  <Radiobox
                    className="m-checkbox-lg"
                    value={payType === PayType.WECHAT}
                    onChange={(v) => setpayType(v ? PayType.WECHAT : '')}
                  />
                </div>
              )}
              {enabledPayTypes.includes(PayType.ALIPAY) && (
                <div
                  className="d-flex-r ai-center jc-between font-size-14 pv-8"
                  onClick={() => setpayType(payType === PayType.ALIPAY ? '' : PayType.ALIPAY)}
                >
                  <div className="d-flex-r ai-center">
                    <img className="w-20 h-20 mr-10" src="/pic/icon_zfb.png" alt="" />
                    <span className="d-inline-block line-height-0">支付宝支付</span>
                  </div>
                  <Radiobox
                    className="m-checkbox-lg"
                    value={payType === PayType.ALIPAY}
                    onChange={(v) => setpayType(v ? PayType.ALIPAY : '')}
                  />
                </div>
              )}
              {enabledPayTypes.includes(PayType.LFT) && (
                <div
                  className="d-flex-r ai-center jc-between font-size-14 pv-8"
                  onClick={() => setpayType(payType === PayType.LFT ? '' : PayType.LFT)}
                >
                  <div className="d-flex-r ai-center">
                    <img className="w-20 h-20 mr-10" src="/pic/icon_pay_wechat.png" alt="" />
                    <span className="d-inline-block line-height-0">龙付通支付</span>
                  </div>
                  <Radiobox
                    className="m-checkbox-lg"
                    value={payType === PayType.LFT}
                    onChange={(v) => setpayType(v ? PayType.LFT : '')}
                  />
                </div>
              )}
            </div>
          )}
          <div className="goods-detail-html" dangerouslySetInnerHTML={{ __html: detail.goodsDetail ?? '' }}></div>
        </div>
        {detail.hideShare ? (
          <div className="bg-color-white p-20 ai-center">
            <div
              className="bw-100 h-40 border-radius-40 goods-detail-right-btn text-color-white text-center"
              onClick={handleSubmitOrder}
            >
              <div className="font-size-16">{formatNumber(detail.goodsPrice ?? 0)}元</div>
              <div className="font-size-10">立即办理</div>
            </div>
          </div>
        ) : (
          <div className="bg-color-white p-20 d-flex-r ai-center">
            <div
              className="d-flex-c ai-center"
              onClick={() => navigate('/?userId=' + shareUserId, { replace: canBack })}
            >
              <img className="w-26 h-26" src={main.pic('icon_goods_list.png')} alt="" />
              <div className="font-size-12">商品列表</div>
            </div>
            <div className="flex-1" />
            <div
              className="lh-40 text-center w-100 h-40 border-radius-tl-40 border-radius-bl-40 goods-detail-left-btn font-size-16 text-color-white"
              onClick={handleToShare}
            >
              分享
            </div>
            <div
              className="w-100 h-40 d-flex-c ai-center jc-center text-center border-radius-tr-40 border-radius-br-40 goods-detail-right-btn text-color-white"
              onClick={handleSubmitOrder}
            >
              <div className="font-size-16">
                {freight > 0
                  ? formatNumber(freight + Number(detail.goodsPrice ?? 0))
                  : formatNumber(detail.goodsPrice ?? 0)}
                元
              </div>
              <div className="font-size-10">立即办理</div>
            </div>
          </div>
        )}
      </div>
      <div className="pos-a t-0 l-0 r-0 d-flex-r jc-between pv-20 ph-10">
        {canBack ? (
          <div
            className="w-26 h-26 border-radius-20 bg-color-3-t5 d-flex-r ai-center jc-center"
            onClick={() => {
              navigate(-1);
            }}
          >
            <img className="w-24 h-24" src={main.pic('icon_back_white.png')} alt="" />
          </div>
        ) : (
          <div />
        )}
        {!detail.hideShare && (
          <div
            className="w-26 h-26 border-radius-20 bg-color-3-t5 d-flex-r ai-center jc-center"
            onClick={handleToShare}
          >
            <img className="w-20 h-20" src={main.pic('icon_export_white.png')} alt="" />
          </div>
        )}
      </div>
    </Page>
  );
}
